import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { DataService } from '../shared/data.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { map, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';

export class StoreData {
  traffic: {
    CurrentClientTraffic: number;
    TotalStoreCapacity: number;
    TotalStoreTime: number;
    TotalCustomerCount: number;
  };
  data: StoreDetails;
  logo: null;
  descriptionImg: null;
}
export class StoreDetails {
  Name: string;
  AddressLocalized: [string, string];
  DescriptionLocalized: [string, string];
  OpeningHoursLocalized: [{}, {}];
  PhoneNumber: string;
  WebsiteURL: string;
  MapsURL: string;
}

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.css'],
})
export class WorkspaceComponent implements OnInit {
  store: StoreData;

  constructor(
    public auth: AuthService,
    public dataService: DataService,
    private storage: AngularFireStorage
  ) {
    this.store = new StoreData();
    this.store.data = new StoreDetails();
    this.store.data.Name = 'Base Name';
    this.store.data.AddressLocalized = [' English Address ', 'French Adresse '];
    this.store.data.OpeningHoursLocalized = [
      ' { 	 	"Monday":"8:00am - 10:00pm", 	 	"Tuesday":"8:00am - 10:00pm",  	"Wednesday":"8:00am - 10:00pm",  	"Thursday":"8:00am - 10:00pm",  	"Friday":"8:00am - 10:00pm" } ',
      '{"Lundi":"8:00am - 10:00pm","Mardi":"8:00am - 10:00pm","Mercredi":"8:00am - 10:00pm",  	"Jeudi":"8:00am - 10:00pm","Vendredi":"8:00am - 10:00pm" }',
    ];
    this.store.data.DescriptionLocalized = [
      ' English Description ',
      ' Description Francaise ',
    ];
    this.store.data.PhoneNumber = '';
    this.store.data.WebsiteURL = '';
    this.store.data.MapsURL = '';
    this.store.logo = null;
    this.store.descriptionImg = null;
  }

  ngOnInit(): void {}

  onTrafficAdded(event) {
    const traffic = {
      CurrentClientTraffic: 0,
      TotalStoreCapacity: event.target.valueAsNumber as number,
      TotalStoreTime: 0,
      TotalCustomerCount: 1,
    };

    this.store.traffic = traffic;
  }

  onLogoSelected(event) {
    const logo = event.target.files[0];
    this.store.logo = logo;
  }

  onDescriptionImgSelected(event) {
    const descriptionImg = event.target.files[0];
    this.store.descriptionImg = descriptionImg;
  }

  onSubmit() {
    const data = this.store;

    this.dataService.createStore(this.store);
  }
}
